export enum DeviceType {
  desktop = 'desktop',
  tablet = 'tablet',
  phone = 'phone',
}
